import { render, staticRenderFns } from "./AppFrequentSearchesBlock.vue?vue&type=template&id=444275ee&scoped=true"
import script from "./AppFrequentSearchesBlock.vue?vue&type=script&lang=js"
export * from "./AppFrequentSearchesBlock.vue?vue&type=script&lang=js"
import style0 from "./AppFrequentSearchesBlock.vue?vue&type=style&index=0&id=444275ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444275ee",
  null
  
)

export default component.exports